import { setAuthAction } from '@app/store/auth';
import { all, takeEvery } from 'redux-saga/effects';
import { fetchUserSaga } from './fetchUserSaga';

export function* userSagaWatcher() {
  yield all([takeEvery(setAuthAction.TYPE, fetchUserSaga)]);
}
